import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { useChosenDepartment } from "../../contexts/ChosenDepartment";
import type { NurseFullRole } from "../../utils/models";
import { getUniqueLocations } from "../../utils/utilFunctions";
import { SystemDropdown } from "../UIToolkit/Inputs/SystemDropDown/SystemDropdown";

interface IProps {
	nurseId: number;
	weekIndex: number;
	dayIndex: number;
	shiftIndex: number;
	role: NurseFullRole;
	room: string;
	setRoom: (room: string) => void;
}

export const ShiftDataRoomList = ({ nurseId, weekIndex, dayIndex, shiftIndex, role, room, setRoom }: IProps) => {
	const { chosenDepartment } = useChosenDepartment();

	const rooms: string[] = useMemo(() => {
		return getUniqueLocations(chosenDepartment.locations, false).map((loc) => loc.location);
	}, [chosenDepartment]);

	return (
		<Box sx={{ mb: 2 }}>
			<Typography
				sx={{
					color: "primary.main",
					mb: 0.5,
					fontSize: "13px",
				}}
			>
				Choose Location
			</Typography>
			<SystemDropdown items={rooms} selectedItem={room} onChange={(v) => v !== undefined && setRoom(v)} fullWidth data-testid="shift-data-location" />
		</Box>
	);
};
